import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/usuarios',
  name: 'usuarios',
  component: Index,
  children: [
    { path: 'listar', name: 'usuarios-listar', component: Listar },
    { path: 'novo', name: 'usuarios-novo', component: Novo },
    { path: ':id', name: 'usuarios-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'usuarios-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/usuarios/routes.js